<div *ngIf="licenseChecked" style="height: 50rem;width: 100%;background-color: #330360;padding-top:10%;"
    class="container-fluid  d-flex justify-content-center ">
    <app-license-page (licensePass)='licenceValue($event)'></app-license-page>
</div>

<div *ngIf="!licenseChecked">
    <!-- <app-user-header [image]=imagepath></app-user-header> -->
    <app-user-header *ngIf="!isMonitorScreen" [image]=imagepath></app-user-header>
    <main>
        <!-- <div class="side-nav changeByView">
            <app-left-side-bar></app-left-side-bar>
        </div> -->
        <div *ngIf="!isMonitorScreen" class="side-nav changeByView">
            <app-left-side-bar></app-left-side-bar>
        </div>

        <div class="main-content changeByViewMain" [ngClass]="{'monitor-main-content': isMonitorScreen}">
            <div class="container-fluid ">
                <router-outlet></router-outlet>
            </div>
            <!-- <float-patient-waiting-list></float-patient-waiting-list> -->
            <float-patient-waiting-list *ngIf="!isMonitorScreen"></float-patient-waiting-list>
        </div>
    </main>
    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasLeft" aria-labelledby="offcanvasLeftLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasLeftLabel">Offcanvas right</h5>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <app-waiting-list></app-waiting-list>
        </div>
    </div>


    <!-- Previous Bootstrap idle modal kept for reference.
    <div bsModal #childModal="bs-modal" class="modal fade">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 id="dialog-child-name" class="modal-title pull-left">You Have Been Idle!</h4>
                    <button type="button" class="close pull-right" aria-label="Close" (click)="continue()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="text-left"><span style="font-size: medium;">Time Remain - </span>
                        <span class="text-primary"><i class="pi pi-spin pi-clock"></i>
                            {{this.secondTimerLeft}}</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success pull-right" (click)="continue()">Stay</button>
                    <button type="button" class="btn btn-danger pull-left" (click)="logout()">Logout</button>
                </div>
            </div>
        </div>
    </div>
    -->

    <div bsModal #childModal="bs-modal" class="modal fade">
        <div class="fixed inset-0 z-[1060] flex min-h-screen items-center justify-center bg-slate-950/55 px-4 py-6">
            <div class="relative w-full max-w-[430px] rounded-2xl bg-white px-6 pb-6 pt-8 text-center shadow-2xl sm:px-7">
                <button type="button" aria-label="Close" (click)="continue()"
                    class="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full border-0 bg-slate-100 p-0 text-xl leading-none text-slate-500 transition hover:bg-slate-200 hover:text-slate-700">
                    <i class="las la-times block leading-none"></i>
                </button>

                <div class="mx-auto mb-3 grid h-20 w-20 place-items-center rounded-full bg-orange-100 text-[42px] text-orange-600">
                    <i class="las la-clock"></i>
                </div>

                <h2 class="m-0 text-2xl font-bold leading-tight text-slate-900">
                    You Have Been Idle!
                </h2>

                <p class="mx-auto mt-3 max-w-[340px] text-[15px] leading-6 text-slate-500">
                    Time remaining
                    <span class="ml-1 inline-flex items-center font-bold text-orange-600">
                        <i class="pi pi-spin pi-clock mr-1"></i>
                        {{ secondTimerLeft }}
                    </span>
                </p>

                <div class="mt-7 flex flex-col-reverse justify-center gap-2 sm:flex-row">
                    <button type="button" (click)="continue()"
                        class="inline-flex h-10 w-full items-center justify-center whitespace-nowrap rounded-lg border-0 bg-teal-700 px-4 text-sm font-semibold leading-none text-white transition hover:bg-teal-800 sm:w-auto sm:min-w-[92px]">
                        Stay
                    </button>
                    <button type="button" (click)="logout()"
                        class="inline-flex h-10 w-full items-center justify-center whitespace-nowrap rounded-lg border-0 bg-red-600 px-4 text-sm font-semibold leading-none text-white transition hover:bg-red-700 sm:w-auto sm:min-w-[92px]">
                        Logout
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
